module.exports = __webpack_public_path__ + "img/印象丽江1_1.ea25c87c.jpg";